import * as  moment from 'moment';

export class Bitacora {
    public FechaInicial: string;
    public FechaFinal: string;
    public Pagina: number;
    public Parametro: string;
    public EsReporte: number;
    public TipoBitacora: string;

    constructor() {
        const formatoSalida = 'YYYY-MM-DD';
        const formatoEntrada = 'YYYY-MM-DDTHH:mm:ss Z';
        const fechaInicial = moment(
            new Date(new Date().getFullYear(), new Date().getMonth(), 1), formatoEntrada
        );
        const fechaFinal = moment(
            new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), formatoEntrada
        );
        this.FechaInicial = fechaInicial.format(formatoSalida);
        this.FechaFinal = fechaFinal.format(formatoSalida);
        this.Parametro = "";
        this.Pagina = 1;
        this.EsReporte = 0;
        this.TipoBitacora = "";
    }
}
